import React from 'react';
import HeroBanner from './components/HeroBanner';
import AnimatedSection from './components/AnimatedSection';
import GifSection from './components/GifSection';
import Footer from './components/Footer';

// ─── Local images from public/images/ — ordered as per WordPress page ─────────

const BANNER_IMAGE = '/images/Banner-1-1-1536x1084.png';

const ANIMATED_GIF = '';

const GIF_SECTIONS: { src: string; alt: string }[] = [
    { src: '/images/Your-paragraph-text-19-1-6.gif',    alt: 'Black Beauty Feature 1' },

  { src: '/images/Your-paragraph-text-4.gif',    alt: 'Black Beauty Feature 1' },
  { src: '/images/Your-paragraph-text-25.gif',   alt: 'Black Beauty Feature 2' },
  { src: '/images/Your-paragraph-text-1-2.gif',  alt: 'Black Beauty Feature 3' },
  { src: '/images/Your-paragraph-text-27-1.gif', alt: 'Black Beauty Feature 4' },
  { src: '/images/Your-paragraph-text-21.gif',   alt: 'Black Beauty Feature 5' },
  { src: '/images/Your-paragraph-text-29.gif',   alt: 'Black Beauty Feature 6' },
  { src: '/images/Your-paragraph-text-33.gif',   alt: 'Black Beauty Feature 7' },
  { src: '/images/Your-paragraph-text-32.gif',   alt: 'Black Beauty Feature 8' },
  // { src: '/images/Your-paragraph-text-4.gif',    alt: 'Black Beauty Feature 9' },
];

const FOOTER_SOCIAL_LINKS = [
  { label: 'Facebook',  href: 'https://www.facebook.com/blackbeautytalcpowder' },
  { label: 'Instagram', href: 'https://www.instagram.com/blackbeautypk/' },
  { label: 'YouTube',   href: 'https://youtube.com/@blackbeautycosmetics' },
];

const App: React.FC = () => {
  return (
    <main>
      {/* Component 1: Hero Banner */}
      <HeroBanner
        imageSrc={BANNER_IMAGE}
        imageAlt="Black Beauty Cosmetics – Hero Banner"
      />

      {/* Component 2: Animated Full-Screen GIF */}
      {/* <AnimatedSection
        imageSrc={ANIMATED_GIF}
        imageAlt="Black Beauty Cosmetics – Animated Feature"
      /> */}

      {/* Component 3: GIF Sections ×9 — WordPress page order */}
      {GIF_SECTIONS.map((gif, index) => (
        <GifSection
          key={`gif-section-${index}`}
          gifSrc={gif.src}
          gifAlt={gif.alt}
          index={index}
        />
      ))}

      {/* Component 4: Footer */}
      <Footer
        logoSrc="/images/Black-Beauty-English-e1747058383772-1024x273.png"
        logoAlt="Black Beauty Cosmetics Logo"
        watermarkLogoSrc="/images/Logo-1.png"
        watermarkLogoAlt="Black Beauty Watermark"
        phone="+92 322 0066783"
        email="blackbeautycosmeticspk@gmail.com"
        socialLinks={FOOTER_SOCIAL_LINKS}
        copyrightText="Copyright © 2024 BlackBeauty.pk. All Rights Reserved."
      />
    </main>
  );
};

export default App;